import SliceNames from '@/state/enum';
import { SavedBuildsState } from '@/state/slices/saved-builds/typings';

const buildCounts = globalThis.sessionStorage.getItem('buildCounts');
let parsedBuildCounts: SavedBuildsState[SliceNames.SAVED_BUILDS]['buildCounts'] =
	{};

if (buildCounts) {
	try {
		parsedBuildCounts = JSON.parse(buildCounts);
	} catch {}
}

const savedBuildsState: SavedBuildsState = {
	[SliceNames.SAVED_BUILDS]: {
		buildCounts: parsedBuildCounts,
		buildData: {},
	},
};

export default savedBuildsState;
